import { AxiosResponse } from "axios";
import { ThunkDispatch } from "redux-thunk";
import aa from "search-insights";

import { createApiFor } from "@api/hooks/utils";

import { StorageKeys } from "@utils/enums";
import { attemptMethod } from "@utils/general";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";

import { set } from "@redux/modules/value/search/search.module";
import { AlgoliaParameters } from "@redux/modules/value/search/search.types";
import { IState, TExtraThunkArgs, TValueAction } from "@redux/store.types";

import { GenerateAlgoliaParametersRequestApiModel } from "../../../@types/service/search/generateAlgoliaParametersRequest.api.model";
import { GenerateAlgoliaParametersResponseApiModel } from "../../../@types/service/search/generateAlgoliaParametersResponse.api.model";

enum AlgoliaParametersRequestStatus {
    IDLE = "IDLE",
    PENDING = "PENDING",
}

const axios = createApiFor(``, { bff: true });
let status = AlgoliaParametersRequestStatus.IDLE;

const areAlgoliaParametersPending = () =>
    status === AlgoliaParametersRequestStatus.PENDING;

const getSessionsStorageAlgoliaParameters = () =>
    attemptMethod<AlgoliaParameters | undefined>(
        () =>
            JSON.parse(
                sessionStorage.getItem(StorageKeys.AlgoliaParameters) ?? "",
            ),
        undefined,
    );

const setSessionsStorageAlgoliaParameters = (
    algoliaParameters: AlgoliaParameters,
) =>
    sessionStorage.setItem(
        StorageKeys.AlgoliaParameters,
        JSON.stringify(algoliaParameters),
    );

const generateAlgoliaParameters: (
    dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
) => Promise<AlgoliaParameters> = async dispatch => {
    status = AlgoliaParametersRequestStatus.PENDING;

    const { data } = await axios.post<
        GenerateAlgoliaParametersResponseApiModel,
        AxiosResponse<GenerateAlgoliaParametersResponseApiModel>,
        GenerateAlgoliaParametersRequestApiModel
    >(`/search/generateAlgoliaParameters`, {
        userToken:
            AlgoliaTrackingService.getAuthenticatedUserToken() ??
            AlgoliaTrackingService.getUserToken(),
    });

    dispatch(
        set({
            algoliaParameters: data,
        }),
    );

    status = AlgoliaParametersRequestStatus.IDLE;

    setSessionsStorageAlgoliaParameters(data);

    aa("init", {
        partial: true,
        appId: data.appId,
        apiKey: data.searchApiKey,
    });

    return data;
};

export {
    generateAlgoliaParameters,
    areAlgoliaParametersPending,
    getSessionsStorageAlgoliaParameters,
};
